import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {INewsPost} from '@api/models/news/news';
import {IUTMParameters} from '@utils/services/url/url.service';
import {NewsService} from '@core/services/news.service';
import {IPicture} from '@api/models/image/picture';
import {ContentCardAlignment, ContentCardLayout} from '../content-card/content-card.component';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';

@Component({
  selector: "lib-news-card",
  templateUrl: "./news-card.component.html",
  styleUrls: ["./news-card.component.scss"],
})
export class NewsCardComponent implements OnChanges {
  @Input() public news: INewsPost;
  @Input() public utmParams: IUTMParameters;
  @Input() public lazyLoadImage = true;
  @Input() public preloadImage = false;
  @Input() public containImage = false;
  @Input() public minImageHeight: string;
  @Input() public maxImageHeight: string;
  @Input() public aspectRatio: string;
  @Input() public imageResolution = IMAGE_RESOLUTION.MEDIUM;
  @Input() public colorScheme = ColorScheme.Dark;
  @Input() public layout: ContentCardLayout;
  @Input() public splitAlignment = ContentCardAlignment.Right;
  public picture: IPicture;
  public preTitle: string;
  public title: string;
  private studioTitle = 'studiosendung';

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.news && this.news) {
      if (this.news.pictures?.length > 0) {
        this.picture = this.news.pictures[0];
      } else if (
        this.news.videos_native?.length > 0 &&
        this.news.videos_native[0]?.preview
      ) {
        this.picture = this.news.videos_native[0].preview;
      }
      this.setTitles();
    }
  }

  private setTitles(): void {
    // Temporary fix for long studio titles, TODO: remove when studio news have presentable titles
    if (this.layout === ContentCardLayout.SquareThumbnail
      && this.news.title.toLowerCase().includes(this.studioTitle)) {
      this.title = this.news.title.toLowerCase().replace(this.studioTitle, '');
      this.preTitle = this.studioTitle;
    } else {
      this.title =
        NewsService.replaceFacebookImportTitle(this.news) ??
        this.news.preview_text;
      this.preTitle = this.news.pretitle;
    }
  }
}
